import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";


const __default__ = {
  name: "SelectableImageGroup",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  imageList: {
    type: Array as PropType<string[]>,
    required: true,
  },
  selectedImageList: {
    type: Array as PropType<string[]>,
    required: true,
  },
  selectedImageIndexes: {
    type: Array as PropType<number[]>,
    required: true,
  },
  imageAltTextList: {
    type: Array as PropType<string[]>,
    required: true,
  },
},
  emits: ["onClickImage"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const emitOnClickImage = (index: number) => {
  emit("onClickImage", index);
};

const isSelectedImage = (index: number) => {
  return props.selectedImageIndexes.includes(index);
};

const __returned__ = { props, emit, emitOnClickImage, isSelectedImage }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})